import React, { type FC } from "react";
import { CarConfigConfigureSection } from "../../../utils/types/SectionTypes";
import Button from "../../../../shared-components/css-modules/toyota/atoms/Button";
import { trackBottomNavigationClick } from "../../../utils/tracking";
import { type CarConfigDispatchType, useCarConfigSelector } from "../../../redux/store";
import styles from "../common/navigation/Navigation.module.scss";
import { useCarouselContext } from "../../../../shared-components/css-modules/toyota/vendor/carousel/CarouselContext";
import { setActiveSpin, SpinnerType } from "../../../redux/slices/CarConfigSpinNavigationSlice";
import { CarConfigLabel } from "../../../utils/labelUtils";
import type { CarConfigLabelType } from "../../../utils/labels";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const sectionLabelMap: { [key in CarConfigConfigureSection]: CarConfigLabelType } = {
    [CarConfigConfigureSection.Engine]: "carConfigEngine",
    [CarConfigConfigureSection.Colour]: "carConfigColour",
    [CarConfigConfigureSection.Wheels]: "carConfigWheels",
    [CarConfigConfigureSection.Upholstery]: "carConfigUpholstery",
    [CarConfigConfigureSection.Packs]: "carConfigPacksAndExtras",
    [CarConfigConfigureSection.Charging]: "carConfigCharging",
    [CarConfigConfigureSection.Services]: "carConfigServicesTitle",
    [CarConfigConfigureSection.Summary]: "carConfigOverviewTitle",
};

const ConfigureNavigationButton: FC<{ section: CarConfigConfigureSection; index: number }> = ({ section, index }) => {
    const activeSection = useCarConfigSelector((state) => state.carConfigNavigation.activeSection);
    const { carouselProperties } = useCarouselContext();
    const dispatch = useDispatch<CarConfigDispatchType>();

    const addNode = carouselProperties?.addNode;

    return (
        <li ref={addNode ? (node) => addNode(node, index) : null}>
            <Button
                href={`#${section}`}
                variant="clean"
                className={`${styles["nav-link"]} ${activeSection === section ? ` ${styles.active}` : ""}`}
                onClick={() => {
                    // This prevents the history being pushed with each section change. This way the browser back button goes to the previous page.
                    window.history.replaceState(window.history.state, "", `#${section}`);

                    if (section === CarConfigConfigureSection.Upholstery) {
                        dispatch(setActiveSpin(SpinnerType.Upholstery));
                    } else {
                        dispatch(setActiveSpin(SpinnerType.Car));
                    }

                    trackBottomNavigationClick(section, activeSection!);
                }}
                aria-current={activeSection === section}
            >
                <span>
                    {index + 1}. <CarConfigLabel label={sectionLabelMap[section]} />
                </span>
            </Button>
        </li>
    );
};

export default ConfigureNavigationButton;
